import ajax from 'utils/ajax'
import API from 'api-url'

class StudentService {
  // 传世币余额
  myCoin () {
    return ajax.get({
      url: API.student.myCoin
    })
  }

  // 我的传世币记录
  myCoinRecord (params) {
    return ajax.get({
      url: API.student.myCoinRecord,
      data: {data: params}
    })
  }

  // 到期职豆记录
  myExpirePea (params) {
    return ajax.get({
      url: API.student.myexpirePea,
      data: {data: params}
    })
  }

  // 我的活动职豆记录
  myActiveCoin (params) {
    return ajax.get({
      url: API.student.myActiveCoin,
      data: {data: params}
    })
  }

  // 传世币余额充值列表
  rechargeList (params) {
    return ajax.get({
      url: API.student.rechargeList,
      data: {data: params}
    })
  }

  // 新增用户履历
  userPersonal (params) {
    return ajax.post({
      url: API.student.userPersonal,
      data: params
    })
  }
  // 用户履历列表
  userPersonalList (params) {
    return ajax.get({
      url: API.student.userPersonalList,
      data: {data: params}
    })
  }

  // 删除用户履历
  userPersonalDe (id) {
    return ajax.delete({
      url: API.student.userPersonalDe.format(id)
    })
  }

  // 用户履历详情
  userPersonalDetail (id) {
    return ajax.get({
      url: API.student.userPersonalDetail.format(id)
    })
  }

  // 用户履历修改
  userPersonalUpdate (params, id) {
    return ajax.put({
      url: API.student.userPersonalUpdate.format(id),
      data: params
    })
  }

  // 用户履历统计
  userPersonalCount (params) {
    return ajax.get({
      url: API.student.userPersonalCount,
      data: {data: params}
    })
  }

  // 新增用户素质
  newAddQuality (params) {
    return ajax.post({
      url: API.student.newAddQuality,
      data: params
    })
  }

  // 修改用户素质
  modifyQuality (params, id) {
    return ajax.put({
      url: API.student.modifyQuality.format(id),
      data: params
    })
  }

  // 用户素质列表
  qualityList (params) {
    return ajax.get({
      url: API.student.newAddQuality,
      data: {data: params}
    })
  }

  // 删除用户履历
  userQualitylDe (id) {
    return ajax.delete({
      url: API.student.userQualitylDe.format(id)
    })
  }

  // 用户素质详情
  userQualitylDetail (id) {
    return ajax.get({
      url: API.student.userQualitylDe.format(id)
    })
  }

  // 用户素质统计
  userQualitylCount (params) {
    return ajax.get({
      url: API.student.userQualitylCount,
      data: {data: params}
    })
  }

  // 用户知识点列表
  knowledge (params) {
    return ajax.get({
      url: API.student.knowledge,
      data: {data: params}
    })
  }

  // 班级列表
  learingClass () {
    return ajax.get({
      url: API.student.learingClass
    })
  }

  // 我的班级
  myClass () {
    return ajax.get({
      url: API.student.myClass
    })
  }

  // 附件简历列表
  resume () {
    return ajax.get({
      url: API.student.resume
    })
  }

  // 上传附件简历
  createResume (params) {
    return ajax.post({
      url: API.student.resume,
      data: params
    })
  }

  // 删除附件简历
  deleteResume (params) {
    return ajax.delete({
      url: API.student.resume,
      data: {data: params}
    })
  }

  // 获取用户信息
  studentinfo (id) {
    return ajax.get({
      url: API.student.studentinfo.format(id)
    })
  }

  // 修改用户信息
  studentUpdate (params, id) {
    return ajax.put({
      url: API.student.studentinfoUpdate,
      data: params
    })
  }

  statistics () {
    return ajax.get({
      url: API.student.statistics
    })
  }

  // 技能树列表
  treeList (params) {
    return ajax.get({
      url: API.tree.source,
      data: {data: params}
    })
  }

  // 日志列表
  myDailyList (params) {
    return ajax.get({
      url: API.student.myDailyList,
      data: {data: params}
    })
  }

  // 日至评审
  appr (params) {
    return ajax.post({
      url: API.student.appr.format(params.id),
      data: params
    })
  }

  //  我的信息
  myInfo () {
    return ajax.get({
      url: API.student.myInfo
    })
  }

  //  我的信息
  meInfo () {
    return ajax.get({
      url: API.student.meInfo
    })
  }

  //  用户的信息
  userInfo (id) {
    return ajax.get({
      url: API.student.userInfo.format(id)
    })
  }

  // 辅导老师的学生列表
  myStudent () {
    return ajax.get({
      url: API.student.myStudent
    })
  }

  // 用户岗位列表
  myOfferList(params) {
    return ajax.get({
      url: API.student.myOfferList,
      data: {
        data: params
      }
    })
  }

  // 用户岗位统计
  myOfferListCount () {
    return ajax.get({
      url: API.student.myOfferListCount
    })
  }

  // 收藏岗位列表
  favoritePosition (params) {
    return ajax.get({
      url: API.student.favoritePosition,
      data: {
        data: params
      }
    })
  }
  // 考试结束交卷
  submitExam (id, params) {
    return ajax.post({
      url: API.student.submitExam.format(id),
      data: params
    })
  }
  // 岗位测试结束提交
  examPositionSubmit (id, params) {
    return ajax.post({
      url: API.student.examPositionSubmit.format(id),
      data: params
    })
  }
  openexamPositionSubmit (id, params) {
    return ajax.post({
      url: API.company.openexamPositionSubmit.format(id),
      data: params
    })
  }
  // 用户测试考题列表
  examTest (params) {
    return ajax.get({
      url: API.student.examTest,
      data: {data: params}
    })
  }
  // 用户考试列表
  myExamList (params) {
    return ajax.get({
      url: API.student.myExamList,
      data: {data: params}
    })
  }

  // 我的监考列表
  myProctor (params) {
    return ajax.get({
      url: API.student.myProctor,
      data: {data: params}
    })
  }

  // 考试大厅
  query (params) {
    return ajax.get({
      url: API.student.query,
      data: {data: params}
    })
  }
  // 监考老师确认在线
  startProctor(id) {
    return ajax.put({
      url: API.student.startProctor.format(id)
    })
  }
  // 监考老师抢单
  grab (id) {
    return ajax.get({
      url: API.student.grab.format(id)
    })
  }
  // 用户问答列表
  myAskList () {
    return ajax.get({
      url: API.student.myAskList
    })
  }

  // 用户申请岗位
  offerApply (params) {
    return ajax.post({
      url: API.student.offerApply,
      data: params
    })
  }

  // 职业列表
  proList () {
    return ajax.get({
      url: API.student.proList
    })
  }

  // 职业报名
  professionCreate (params) {
    return ajax.post({
      url: API.student.professionCreate,
      data: params
    })
  }

  // 职业优选企业
  professionCompany (id, params) {
    return ajax.get({
      url: API.student.professionCompany.format(id),
      data: {data: params}
    })
  }

  // 职业报名求职者
  professionStudent (params) {
    return ajax.get({
      url: API.student.professionStudent,
      data: {data: params}
    })
  }

  // 知识库新建
  CounselorCreate (params) {
    return ajax.post({
      url: API.student.CounselorCreate,
      data: params
    })
  }

  // 知识库修改
  CounselorUpdate (params, id) {
    return ajax.put({
      url: API.student.CounselorUpdate.format(id),
      data: params
    })
  }

  // 知识库删除
  CounselorDelete (id) {
    return ajax.delete({
      url: API.student.CounselorDelete.format(id)
    })
  }

  // 某个文件夹下文章列表
  CounselorFile (params, id) {
    return ajax.get({
      url: API.student.CounselorFile.format(id),
      data: {data: params}
    })
  }

  // 知识库详情
  CounselorDetail (id) {
    return ajax.get({
      url: API.student.CounselorDetail.format(id)
    })
  }

  // 知识库文件列表
  CounselorPackage () {
    return ajax.get({
      url: API.student.CounselorPackage
    })
  }

  // 知识库列表
  CounselorList (params) {
    return ajax.get({
      url: API.student.CounselorList,
      data: {data: params}
    })
  }

  // 我的任务列表
  myTask () {
    return ajax.get({
      url: API.student.myTaskList
    })
  }

  // 任务列表
  taskList (params) {
    return ajax.get({
      url: API.student.taskList,
      data: params
    })
  }

  startTask (params) {
    // 任务详情
    return ajax.get({
      url: API.student.startTask,
      data: {data: params}
    })
  }

  // 用户求职意向
  ExpectedPosition () {
    return ajax.get({
      url: API.student.myExpectedPosition
    })
  }
  // 用户求职意向删除
  ExpectedPositionDelete (id) {
    return ajax.delete({
      url: API.student.myExpectedPositionDelete.format(id)
    })
  }
  // 用户求职意向创建
  ExpectedPositionCreate (params) {
    return ajax.post({
      url: API.student.myExpectedPositionCreate,
      data: params
    })
  }

  // 用户求职意向修改
  ExpectedPositionUpdate (params, id) {
    return ajax.put({
      url: API.student.myExpectedPositionUpdate.format(id),
      data: params
    })
  }

  // 用户求职意向详情
  ExpectedPositionDetail (id) {
    return ajax.get({
      url: API.student.myExpectedPositionDetail.format(id)
    })
  }

  // 用户岗位期望
  userPositionDetail (id) {
    return ajax.get({
      url: API.student.userPositionDetail.format(id)
    })
  }

  // 企业列表
  companyList (params) {
    return ajax.get({
      url: API.student.companyInfoList,
      data: {data: params}
    })
  }

  // 评论列表
  commentList (params) {
    return ajax.notify.get({
      url: API.notify.comment,
      data: {data: params}
    })
  }

  // 发布评论
  // commonComment array<object>
  // commentContent 评论内容 string
  // dataId 评论数据ID number
  // dataType 评论类型 string learning_discussion_answer("知识提问回答平论"), student_daily_record("求职者日志平论"), user_knowledge_base("用户知识库评论");
  // replyedCommentId 被回复评论ID number
  // replyedCommentUserId 被回复评论人 number
  createComment (params) {
    return ajax.post({
      url: API.notify.comment,
      data: params
    })
  }

  // 我的信息
  my () {
    return ajax.get({
      url: API.student.my
    })
  }

  // 我发布的课程列表
  mycourseList (params) {
    /* v: 查询参数键名对应的值
     num: 每页几条
     p: 当前第几页 */
    return ajax.get({
      url: API.student.mycourseList,
      data: {data: params}
    })
  }

  // 开始章节学习
  chapter(params) {
    return ajax.post({
      url: API.student.chapter,
      data: params
    })
  }

  // 完成章节学习
  finishLearn(params) {
    return ajax.post({
      url: API.student.finishLearn,
      data: params
    })
  }

  // 报名学习课程
  learnCourse(params) {
    return ajax.post({
      url: API.student.learnCourse,
      data: params
    })
  }

  // 知识点申请考试
  examCreate (params) {
    return ajax.post({
      url: API.student.examCreate,
      data: params
    })
  }
  // 取消考试
  abandonExam (id) {
    return ajax.put({
      url: API.student.abandonExam.format(id)
    })
  }
  // 某个考试的试题列表
  examPaper (id, params) {
    return ajax.get({
      url: API.student.examPaper.format(id),
      data: {data: params}
    })
  }
  // 岗位测试题列表
  examPositionTest (id, params) {
    return ajax.post({
      url: API.student.examPositionTest.format(id),
      data: {data: params}
    })
  }
  // 考试详情
  examDetail(id) {
    return ajax.get({
      url: API.student.examDetail.format(id)
    })
  }
  // 所有知识点
  knowledgePoints (params) {
    return ajax.get({
      url: API.student.knowledgePoints,
      data: {data: params}
    })
  }

  // 所有知识点
  knowledgePoint(params) {
    return ajax.get({
      url: API.student.knowledgePoint,
      data: { data: params }
    })
  }

  // 学生信息修改
  infoUpdate (params) {
    return ajax.put({
      url: API.student.meInfo,
      data: params
    })
  }
  // 求职者课程数量统计
  courseCount () {
    return ajax.get({
      url: API.student.courseCount
    })
  }
  // 课程购买状态
  courseStatus (type, id) {
    return ajax.get({
      url: API.student.courseStatus.format(type, id)
    })
  }
  // 已签约公司课程
  getCompanyCourse () {
    return ajax.get({
      url: API.student.companyCourse
    })
  }
  // 岗位申请信息
  positionApplyInfo (id) {
    return ajax.get({
      url: API.student.positionApplyInfo.format(id)
    })
  }

  // 职业申请信息
  professionApplyInfo (id) {
    return ajax.get({
      url: API.student.professionApplyInfo.format(id)
    })
  }

  skillCompleted (id) {
    return ajax.get({
      url: API.student.skillCompleted.format(id)
    })
  }

  getJsonTree (params) {
    return ajax.get({
      url: API.student.getJsonTree,
      data: {data: params}
    })
  }

  positionSign(id) {
    return ajax.post({
      url: API.student.positionSign.format(id)
    })
  }
  // 岗位收藏
  collectPosition (params) {
    return ajax.post({
      url: API.student.collectPosition,
      data: params
    })
  }
  // 取消收藏
  deleteCollectPosition (params) {
    return ajax.delete({
      url: API.student.deleteCollectPosition,
      data: {data: params}
    })
  }
  // 是否收藏
  collectPositionStatus (params) {
    return ajax.get({
      url: API.student.collectPositionStatus,
      data: {data: params}
    })
  }
  // 日志数量统计
  recordCount() {
    return ajax.get({
      url: API.student.recordCount
    })
  }
  myLearningMaterial(params) {
    return ajax.get({
      url: API.student.myLearningMaterial,
      data: {data: params}
    })
  }
  // 考点列表
  examPoint(params) {
    return ajax.get({
      url: API.student.examPoint,
      data: {data: params}
    })
  }

  // 考试时间段列表
  timeOptional(params) {
    return ajax.get({
      url: API.student.timeOptional,
      data: {data: params}
    })
  }
  // 全部学生
  allStudent (params) {
    return ajax.get({
      url: API.student.allStudent,
      data: {data: params}
    })
  }
  // 入职学生
  employedStudent(params) {
    return ajax.get({
      url: API.student.employedStudent,
      data: {data: params}
    })
  }
  // 签约学生
  signedStudent(params) {
    return ajax.get({
      url: API.student.signedStudent,
      data: {data: params}
    })
  }
  // 素质信息
  qualityStudent () {
    return ajax.get({
      url: API.student.quality
    })
  }
  // 用户答题详情
  record (id) {
    return ajax.get({
      url: API.student.record.format(id)
    })
  }
  // 注册赠送职豆
  give() {
    return ajax.get({
      url: API.student.give
    })
  }
}

export default new StudentService()



// WEBPACK FOOTER //
// ./src/service/student-service.js